module.exports = __webpack_public_path__ + "static/media/Cross.7cde184d.svg";